module.exports = __webpack_public_path__ + "static/media/guide1.ad27bed9.png";